import React from "react";
import { useParams, Link } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import axios from "axios";
import ShareIcon from "@mui/icons-material/Share";
import GavelIcon from '@mui/icons-material/Gavel';

const DesktopHeader = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      p: 2,
    }}
  >
    <Typography
      variant="h6"
      noWrap
      component={Link}
      to="/"
      sx={{
        fontWeight: 400,
        color: "inherit",
        textDecoration: "none",
        fontSize: { xs: "1rem", md: "1.5rem" },
        "&:hover": { opacity: 0.8 },
      }}
    >
      <Box component="span" sx={{ color: "#F53D3B" }}>
        smooth
      </Box>
      <Box component="span" sx={{ color: "#000000" }}>
        speak
      </Box>
    </Typography>

    <Box
      sx={{
        display: "flex",
        gap: 1,
        alignItems: "center",
        backgroundColor: "rgba(255, 192, 203, 0.2)",
        padding: "8px 16px",
        borderRadius: "20px",
      }}
    >
      <a
        href="https://www.tiktok.com/@smoothspeakai"
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "flex", alignItems: "center" }}
      >
        <img
          src="https://cdn.prod.website-files.com/6706e4607b856db89ebe457b/674d36c17f1b729091ca1277_8547041_tiktok_icon%20(1).svg"
          alt="TikTok"
          style={{ width: "24px", height: "24px" }}
        />
      </a>
      <a
        href="https://www.instagram.com/smoothspeakai/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "flex", alignItems: "center" }}
      >
        <img
          src="https://cdn.prod.website-files.com/6706e4607b856db89ebe457b/674d36920a51536aef34fa9b_5335781_camera_instagram_social%20media_instagram%20logo_icon.svg"
          alt="Instagram"
          style={{ width: "24px", height: "24px" }}
        />
      </a>
      <Typography sx={{ fontSize: "0.9rem", color: "#666", marginLeft: 1 }}>
        Loved by{" "}
        <span style={{ color: "#00A67E", fontWeight: "bold" }}>10,000+</span>{" "}
        users
      </Typography>
    </Box>
  </Box>
);

const MobileHeader = () => (
  <Box sx={{ width: "100%", p: 2 }}>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        mb: 2,
      }}
    >
      <Typography
        variant="h4"
        noWrap
        component={Link}
        to="/"
        sx={{
          fontWeight: 400,
          color: "inherit",
          textDecoration: "none",
          fontSize: "1rem",
          "&:hover": { opacity: 0.8 },
        }}
      >
        <Box component="span" sx={{ color: "#F53D3B" }}>
          smooth
        </Box>
        <Box component="span" sx={{ color: "#000000" }}>
          speak
        </Box>
      </Typography>
    </Box>
  </Box>
);

const SharePage = () => {
  const { referralCode } = useParams();

  const handleShare = async () => {
    try {
      const shareText =
        "Hey! Check out Smoothspeak - it's an AI texting wingman that tells you what to say on dating apps, text and socials. It's completely free!";
      const shareUrl = `${window.location.origin}/signup?ref=${referralCode}`;

      if (navigator.share) {
        await navigator.share({
          title: "Tap to try Smoothspeak 🔥",
          text: shareText,
          url: shareUrl,
        });

        console.log("share completed");
        await axios.post("/api/track-share", {
          referral_code: referralCode,
          event: "share_completed",
        });
      }
    } catch (error) {
      console.log("error", error);
      if (error.name === "AbortError") {
        await axios.post("/api/track-share", {
          referral_code: referralCode,
          event: "share_cancelled",
        });
      } else {
        console.error("Share failed:", error);
      }
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#000000",
        color: "#FFFFFF"
      }}
    >
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <DesktopHeader />
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <MobileHeader />
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: 2,
          paddingTop: { xs: 4, md: 8 },
        }}
      >
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            gap: 1,
            alignItems: "center",
            backgroundColor: "#1C1C1E",
            padding: "8px 16px",
            borderRadius: "20px",
            mb: 2,
          }}
        >
          <a
            href="https://www.tiktok.com/@smoothspeakai"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src="https://cdn.prod.website-files.com/6706e4607b856db89ebe457b/674d36c17f1b729091ca1277_8547041_tiktok_icon%20(1).svg"
              alt="TikTok"
              style={{ width: "20px", height: "20px" }}
            />
          </a>
          <a
            href="https://www.instagram.com/smoothspeakai/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src="https://cdn.prod.website-files.com/6706e4607b856db89ebe457b/674d36920a51536aef34fa9b_5335781_camera_instagram_social%20media_instagram%20logo_icon.svg"
              alt="Instagram"
              style={{ width: "20px", height: "20px" }}
            />
          </a>
          <Typography sx={{ fontSize: "0.7rem", color: "#8E8E93", marginLeft: 1 }}>
            Loved by{" "}
            <span style={{ color: "#00A67E", fontWeight: "bold" }}>1000+</span>{" "}
            users
          </Typography>
        </Box>

        <Box
          sx={{
            maxWidth: 400,
            width: "100%",
            backgroundColor: "#1C1C1E",
            borderRadius: 2,
            padding: 3,
            boxShadow: 3,
            textAlign: "center",
            mb: 4,
          }}
        >
          <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
            <Box component="span" sx={{ color: "#FF3B30" }}>
              smooth
            </Box>
            <Box component="span" sx={{ color: "#FFFFFF" }}>
              speak
            </Box>
          </Typography>

          <Typography variant="body1" sx={{ mb: 3, color: "#8E8E93" }}>
            Share Smoothspeak with friends using your unique referral link below
          </Typography>

          <Button
            variant="contained"
            onClick={handleShare}
            startIcon={<ShareIcon />}
            sx={{
              width: "100%",
              py: 1.5,
              backgroundColor: "#FF3B30",
              "&:hover": {
                backgroundColor: "#E63529",
              },
            }}
          >
            Share
          </Button>
        </Box>

        <Box
          sx={{
            maxWidth: 400,
            width: "100%",
            backgroundColor: "#1C1C1E",
            borderRadius: 2,
            padding: 3,
            boxShadow: 3,
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "6px",
              background: "linear-gradient(90deg, #FF3B30 0%, #FF6B66 100%)",
            }}
          />

          <Typography
            variant="h6"
            sx={{
              mb: 2,
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              color: "#FFFFFF",
            }}
          >
            🎮 Win a PS5!
          </Typography>

          <Box sx={{ mb: 3, textAlign: "center" }}>
            <Typography 
              variant="body1" 
              sx={{ 
                mb: 3, 
                color: "#FFFFFF",
                fontWeight: 500,
                fontSize: "1rem",
              }}
            >
              We're giving away a brand new PS5! Share Smoothspeak with friends to get entries into our prize pool.
            </Typography>
            
            <Typography 
              variant="body2" 
              sx={{ 
                mb: 1, 
                color: "#8E8E93",
                display: "flex", 
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                fontWeight: 500,
                fontSize: "0.9rem"
              }}
            >
              Get 1 entry for each friend who signs up
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: "#8E8E93",
                display: "flex", 
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                fontWeight: 500,
                fontSize: "0.9rem"
              }}
            >
              No limit on entries - share more to win!
            </Typography>
          </Box>

          <Box 
            sx={{ 
              p: 2, 
              mb: 3, 
              backgroundColor: "#1C1C1E",
              borderRadius: 1,
              border: "1px solid #2C2C2E"
            }}
          >
            <Typography 
              variant="body2" 
              sx={{
                fontWeight: 500,
                color: "#FFFFFF",
                fontSize: "1rem"
              }}
            >
              Winner selected on{" "}
              <Box component="span" sx={{ fontWeight: "bold", color: "#FF3B30" }}>
                December 25th, 2024
              </Box>
            </Typography>
          </Box>

          <Button
            variant="outlined"
            component={Link}
            to="/rules"
            startIcon={<GavelIcon />}
            sx={{
              width: "100%",
              py: 1.5,
              borderColor: "#1C1C1E",
              color: "#FFFFFF",
              "&:hover": {
                borderColor: "#2C2C2E",
                backgroundColor: "#1C1C1E",
              },
            }}
          >
            View Official Rules
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SharePage;
